import content_journal_list from './journal-list';
import content_journal_add from './journal-add';
import content_journal_edit from './journal-edit';
import content_journal_detail from './journal-detail';

export default {
    content_journal_list,
    content_journal_add,
    content_journal_edit,
    content_journal_detail,
};
